<template>
	<!-- begin widget-chat -->
	<div v-if="job" class="widget-chat rounded mt-3">
		<ImageModal />
		<!-- begin widget-chat-header -->
		<!--
		<div class="widget-chat-header">
			<div class="widget-chat-header-icon">
				<i class="fas fa-message w-30px h-30px fs-20px bg-yellow text-dark text-center rounded-pill"
					style="line-height: 30px"></i>
			</div>
			<div class="widget-chat-header-content">
				<h4 class="widget-chat-header-title">{{ task.title }}</h4>
				<p class="widget-chat-header-desc">Выполнение начато {{ new
						Date(task.created_at).toLocaleDateString("ru-RU")
				}}</p>
			</div>
		</div>-->
		<!-- end widget-chat-header -->

		<!-- begin widget-chat-body -->
		<div class="widget-chat-body" data-scrollbar="true" data-height="235px">
			<!--<div class="text-center text-gray-500 m-3 fw-bold">Today</div>-->
			<div class="widget-chat-item with-media" :class="(item.user.id == user.id) ? 'end' : 'start'"
				v-for="(item, index)  in job.messages" :key="index">
				<div class="widget-chat-media">
					<img onerror="javascript:this.src='/images/avatar/user.png'" alt=""
						:src="`/images/avatar/` + item.user.avatar" class="user-avatar" width="50" height="50" />
				</div>
				<div class="widget-chat-info">
					<div class="widget-chat-info-container">
						<div class="widget-chat-name text-indigo"> {{ item.user.name }}</div>
						<div class="widget-chat-message pre-formatted">
							{{ item.message }}
							<div class="d-flex flex-wrap">
								<div class="m-2" v-for="(image, index)  in item.images" :key=index>
									<!-- BEGIN image -->
									<img class="imageWrapper" :src="`/images/screen/` + image.name" alt=""
										@click="open(`/images/screen/` + image.name)"
										onerror="javascript:this.src='/assets/img/default/default-image.jpeg'">
									<!-- END image -->
								</div>
							</div>
						</div>
						<div class="widget-chat-time">{{ item.created_at }} </div>
					</div>
				</div>
			</div>
		</div>
		<!-- end widget-chat-body -->

		<!-- begin widget-input -->
		<div class="widget-input">
			<form action="" method="POST" name="">
				<div class="d-flex flex-column">
					<div class="d-flex justify-content-start ms-2">
						<div v-for="(image, index)  in images" :key=index class="imageWrapper me-1 mt-2 mb-2"
							:style="{ 'background-image': `url(${image})` }" style="width: 100px;height: 100px;">
							<div class="d-flex justify-content-end">
								<a @click="removeImage(index)" class="btn  btn-icon btn-circle btn-danger">
									<i class="fa fa-times"></i>
								</a>
							</div>
						</div>
					</div>
					<div class="m-2">
						<validation-observer ref="form">
							<validation-provider #default="{ errors }" name="message" rules="required|min:1|max:5120"
								vid="message">
								<textarea v-model="message" class="form-control" rows="6"></textarea>
								<small v-show="!errors[0]">Распишите по пунктам, что было сделано.</small>
								<small class="text-danger">{{ errors[0] }}</small>

							</validation-provider>
						</validation-observer>
					</div>

					<div class="d-flex justify-content-between ms-2 me-2 mb-2">
						<input @change="pickFile" id="fileUpload" ref="fileInput" type="file" style="display:none;">
						<div @click="chooseFiles()" class="btn btn-white me-2" style="white-space:nowrap">
							<i class="fas  fa-cloud-arrow-up"></i><span class="hide-576 ms-1">Скриншот</span>
						</div>
						<div class="d-flex justify-content-between me-2">
							<div class="me-2">
								<select v-model="status" class="form-select ">
									<option v-for="(status, index)  in statuses" :key=index :value="status.name">
										{{ status.desc }}
									</option>
								</select>
							</div>
							<div class="btn btn-primary w-110px" @click="checkForm()"> <i v-show="loading"
									class="fas fa-circle-notch fa-spin"></i>
								<span v-show="!loading"> Ответить</span>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<!-- end widget-input -->
	</div>
	<!-- end widget-chat -->
</template>

<script>
	import HTTP from "../http";
	import { show_error } from "../message";
	import axios from "axios";
	import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
	import { required } from 'vee-validate/dist/rules';
	extend('required', required);

	export default {

		name: 'UserChat',
		props: ['job', 'task'],
		components: {
			ValidationProvider,
			ValidationObserver
		},
		data() {
			return {
				loading: false,
				message: "",
				status: 'REVIEW',
				previewImage: null,
				images: [],
				files: [],
				user: {},
				statuses: []
			}
		},

		mounted() {
			console.log('job', this.job)
			this.user = JSON.parse(localStorage.getItem('user'))
			if (this.task.user_id == this.user.id) {
				// Admin
				this.statuses = [
					{ name: "ACCEPTED", desc: 'Принято' },
					{ name: "DECLINED", desc: 'Требуется доработка' },
					{ name: "REJECTED", desc: 'Отказано заказчиком' },
					{ name: "ARBITRAGE", desc: 'Арбитраж' }
				]
				this.status = "ACCEPTED"
			} else {
				this.statuses = [
					{ name: "REVIEW", desc: 'Выполнено' },
					{ name: "CANCELED", desc: 'Отказаться от задания' },
					{ name: "ARBITRAGE", desc: 'Арбитраж' }
				]
				this.status = "REVIEW"
			}
		},



		methods: {
			checkForm() {
				this.$refs.form.validate().then(success => {
					if (!success) {
						return;
					}

					if (this.status == 'REVIEW' && this.images.length < this.task.img_cnt) {
						show_error(this.$notify, this.$refs.form, `В вашем отчете должны быть скриншоты.\nМинимальное количество скриншотов: ${this.task.img_cnt}.\nВ вашем отчете сейчас скриншотов: ${this.images.length}\nВ одно сообщение можно добавить несколько скриншотов`)
						return
					}
					this.jobPrompt(this.status)
				})
			},

			open(img) {
				window.eventBus.$emit('image.show', img)
			},
			chooseFiles() {
				document.getElementById("fileUpload").click()
			},
			previewFiles(event) {
				console.log(event.target.files);
			},
			selectImage() {
				this.$refs.fileInput.click()
			},
			pickFile() {
				console.log('pickFile')
				let input = this.$refs.fileInput
				let file = input.files
				if (file && file[0]) {
					this.files.push(file[0])
					let reader = new FileReader
					reader.onload = e => {
						this.previewImage = e.target.result
						this.images.push(e.target.result)
					}
					reader.readAsDataURL(file[0])
				}
			},
			removeImage(index) {
				this.images.splice(index, 1);
			},
			async saveImages(message_id) {
				this.loading = true;
				this.$insProgress.start();
				const config = {
					headers: {
						'content-type': 'multipart/form-data',
						Authorization: `Bearer ${localStorage.access_token}`,
					},
				}

				for (let i = 0; i < this.files.length; i++) {
					const data = new FormData()
					data.append('avatar', this.files[i])
					data.append('message_id', message_id)
					await axios.post('/api/image', data, config)
						.then(response => {
							console.log('response', response)
						}).catch(error => {
							show_error(this.$notify, null, error.response.data)
						})
						.finally(() => {
							console.log('finally')
						})
				}
				this.images = []
				this.files = []
				this.$insProgress.finish();
			},

			jobPrompt(status) {
				console.log(status, this.job.status)
				if (status != this.job.status && status == 'ACCEPTED') {
					this.$swal({
						title: 'Оплатить',
						text: 'Вы уверены что хотите оплатить это задание?',
						type: 'info',
						showCancelButton: true,
						buttonsStyling: false,
						confirmButtonText: 'Оплатить',
						cancelButtonText: 'Отмена',
						confirmButtonClass: 'btn me-2 btn-info',
						cancelButtonClass: 'btn btn-default',
					}).then((result) => {
						if (result.value) {
							this.jobUpdate(status)
						}
					})
				} else if (status != this.job.status && status == 'REJECTED') {
					this.$swal({
						title: 'Отмена задания',
						text: 'Вы уверены что хотите отказать исполнителю? Если исполнитель пожалуется, вы можете потерять рейтинг. ',
						type: 'error',
						showCancelButton: true,
						buttonsStyling: false,
						confirmButtonText: 'Отменить задание',
						cancelButtonText: 'Отмена',
						confirmButtonClass: 'btn me-2 btn-danger',
						cancelButtonClass: 'btn btn-default',
					}).then((result) => {
						if (result.value) {
							this.jobUpdate(status)
						}
					})
				} else if (status != this.job.status && status == 'ARBITRAGE') {
					this.$swal({
						title: 'Арбитраж',
						text: 'Обращение в арбитраж это крайняя мера в решении проблемы с заданием. Пожалуйста, попробуйте разрешить ситуацию с заказчиком самостоятельно. Если у вас появились разногласия в ходе выполнения задания, наши админы помогут вам их разрешить. ',
						type: 'error',
						showCancelButton: true,
						buttonsStyling: false,
						confirmButtonText: 'Обратиться в арбитраж',
						cancelButtonText: 'Отмена',
						confirmButtonClass: 'btn me-2 btn-danger',
						cancelButtonClass: 'btn btn-default',
					}).then((result) => {
						if (result.value) {
							this.jobUpdate(status)
						}
					})
				} else {
					this.jobUpdate(status)
				}
			},
			jobUpdate(status) {
				this.loading = true;
				this.$insProgress.start();
				HTTP()
					.put(`/job/${this.job.id}`, { status, message: this.message })
					.then(async (resp) => {
						await this.saveImages(resp.data.id)
						this.message = ''
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					})
					.finally(() => {
						this.loading = false;
						this.$insProgress.finish();
						window.eventBus.$emit('user.chat.update')
						window.eventBus.$emit('customer.chat.update', this.task.id)
					});

			},
		}
	}
</script>


<style>
.imageWrapper {
	width: 150px;
	height: 150px;
	display: block;
	cursor: pointer;
	object-fit: cover;
}
</style>